import profile_utilities from "../../mixins/ProfileUtilities"
import handles_saving from "../../mixins/HandlesSaving"

import BaseButton from "../../ui/BaseButton"
import OpenIcon from "../../ui/OpenIcon"

const is_setting_page = {
    mixins: [profile_utilities, handles_saving],
    components: {
        BaseButton,
        OpenIcon
    },
    mounted () {
        this.load_data()
    },
    watch: {
        $route: "load_data",
        profile_id: "load_data"
    },
    methods: {
        load_data () {
        }
    }
}

export default is_setting_page
